export default __webpack_public_path__ + "330d40f9d3469c8e913edd6ea61c37f5.woff2";